module.exports = __webpack_public_path__ + "img/9791159255939.0c0ded94.jpg";